module.exports = __webpack_public_path__ + "img/withdraw1.ef7dbed4.jpg";